import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  IconButton,
  FormControl,
  Button,
  Select,
  MenuItem,
  Chip,
  Avatar,
  Box,
  Typography,
  InputAdornment,
  CircularProgress,
  LinearProgress,
  alpha
} from '@mui/material';
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Search as SearchIcon,
  FilterList as FilterIcon,
  Assessment as AssessmentIcon,
  Refresh as RefreshIcon,
  Star as StarIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

// Project import
import { gridSpacing } from 'config.js';

// Static data untuk Penilaian Kinerja
const penilaianData = [
  {
    id: 1,
    employee: {
      name: 'Ahmad Rizki',
      photo: '',
      position: 'Software Developer',
      department: 'IT & Web Master',
      employeeId: 'EMP001'
    },
    period: 'Q1 2024',
    evaluator: 'Budi Manager',
    evaluationDate: '2024-03-31',
    overallScore: 4.5,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 4.5,
      'Produktivitas': 4.8,
      'Komunikasi': 4.2,
      'Kerjasama Tim': 4.6,
      'Inisiatif': 4.3
    }
  },
  {
    id: 2,
    employee: {
      name: 'Siti Nurhaliza',
      photo: '',
      position: 'HR Manager',
      department: 'HR & General Affairs',
      employeeId: 'EMP002'
    },
    period: 'Q1 2024',
    evaluator: 'Direktur HR',
    evaluationDate: '2024-03-31',
    overallScore: 4.8,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 4.9,
      'Produktivitas': 4.7,
      'Komunikasi': 4.8,
      'Kerjasama Tim': 4.9,
      'Inisiatif': 4.7
    }
  },
  {
    id: 3,
    employee: {
      name: 'Budi Santoso',
      photo: '',
      position: 'Marketing Executive',
      department: 'Marketing',
      employeeId: 'EMP003'
    },
    period: 'Q1 2024',
    evaluator: 'Marketing Manager',
    evaluationDate: '2024-03-31',
    overallScore: 3.8,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 3.9,
      'Produktivitas': 3.7,
      'Komunikasi': 4.0,
      'Kerjasama Tim': 3.8,
      'Inisiatif': 3.6
    }
  },
  {
    id: 4,
    employee: {
      name: 'Dewi Lestari',
      photo: '',
      position: 'Accountant',
      department: 'Finance',
      employeeId: 'EMP004'
    },
    period: 'Q1 2024',
    evaluator: 'Finance Manager',
    evaluationDate: '2024-03-31',
    overallScore: 4.2,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 4.3,
      'Produktivitas': 4.1,
      'Komunikasi': 4.0,
      'Kerjasama Tim': 4.2,
      'Inisiatif': 4.1
    }
  },
  {
    id: 5,
    employee: {
      name: 'Eko Prasetyo',
      photo: '',
      position: 'Sales Manager',
      department: 'Sales',
      employeeId: 'EMP005'
    },
    period: 'Q1 2024',
    evaluator: 'Sales Director',
    evaluationDate: '2024-03-31',
    overallScore: 4.6,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 4.7,
      'Produktivitas': 4.5,
      'Komunikasi': 4.6,
      'Kerjasama Tim': 4.5,
      'Inisiatif': 4.7
    }
  },
  {
    id: 6,
    employee: {
      name: 'Fitri Handayani',
      photo: '',
      position: 'Designer',
      department: 'Creative',
      employeeId: 'EMP006'
    },
    period: 'Q1 2024',
    evaluator: 'Creative Director',
    evaluationDate: '2024-03-31',
    overallScore: 4.0,
    status: 'Pending',
    categories: {
      'Kualitas Kerja': 0,
      'Produktivitas': 0,
      'Komunikasi': 0,
      'Kerjasama Tim': 0,
      'Inisiatif': 0
    }
  },
  {
    id: 7,
    employee: {
      name: 'Gunawan Wijaya',
      photo: '',
      position: 'Operations Manager',
      department: 'Operations',
      employeeId: 'EMP007'
    },
    period: 'Q1 2024',
    evaluator: 'Operations Director',
    evaluationDate: '2024-03-31',
    overallScore: 4.4,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 4.5,
      'Produktivitas': 4.3,
      'Komunikasi': 4.4,
      'Kerjasama Tim': 4.5,
      'Inisiatif': 4.3
    }
  },
  {
    id: 8,
    employee: {
      name: 'Hani Kartika',
      photo: '',
      position: 'Customer Service',
      department: 'Customer Service',
      employeeId: 'EMP008'
    },
    period: 'Q1 2024',
    evaluator: 'CS Manager',
    evaluationDate: '2024-03-31',
    overallScore: 4.1,
    status: 'Completed',
    categories: {
      'Kualitas Kerja': 4.2,
      'Produktivitas': 4.0,
      'Komunikasi': 4.3,
      'Kerjasama Tim': 4.1,
      'Inisiatif': 3.9
    }
  }
];

const PenilaianKinerjaPage = () => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [periodFilter, setPeriodFilter] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate loading
    setLoading(true);
    setTimeout(() => {
      setData(penilaianData);
      setLoading(false);
    }, 500);
  }, []);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handlePeriodFilterChange = (event) => {
    setPeriodFilter(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'success';
      case 'pending':
        return 'warning';
      case 'draft':
        return 'info';
      case 'cancelled':
        return 'error';
      default:
        return 'default';
    }
  };

  const getScoreColor = (score) => {
    if (score >= 4.5) return 'success';
    if (score >= 3.5) return 'info';
    if (score >= 2.5) return 'warning';
    return 'error';
  };

  const filteredData = data
    .filter(record => {
      const matchesSearch = record.employee.name.toLowerCase().includes(searchText.toLowerCase()) ||
                           record.employee.position.toLowerCase().includes(searchText.toLowerCase()) ||
                           record.employee.department.toLowerCase().includes(searchText.toLowerCase());
      const matchesStatus = statusFilter === '' || record.status === statusFilter;
      const matchesPeriod = periodFilter === '' || record.period === periodFilter;
      
      return matchesSearch && matchesStatus && matchesPeriod;
    })
    .sort((a, b) => b.overallScore - a.overallScore);

  const uniqueStatuses = [...new Set(data.map(record => record.status))];
  const uniquePeriods = [...new Set(data.map(record => record.period))];

  return (
    <div className="animate-fade-in">
      <Card sx={{ boxShadow: '0 8px 32px rgba(0,0,0,0.1)', borderRadius: 3 }}>
        <CardHeader 
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }} className="shadow-lg">
                <AssessmentIcon />
              </Avatar>
              <Box>
                <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }} className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  Penilaian Kinerja
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }} className="text-gray-600">
                  Evaluasi dan penilaian kinerja karyawan secara berkala
                </Typography>
              </Box>
            </Box>
          }
          action={
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <Button 
                variant="outlined" 
                color="primary" 
                startIcon={<RefreshIcon />} 
                onClick={() => window.location.reload()}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  px: 2,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                {loading ? <CircularProgress size={20} /> : 'Refresh'}
              </Button>
              <Button 
                variant="contained" 
                color="primary" 
                startIcon={<AddIcon />} 
                onClick={() => navigate('/penilaian-kinerja/add')}
                className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
                sx={{ 
                  borderRadius: 2,
                  px: 3,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    transform: 'translateY(-2px)'
                  }
                }}
              >
                ✨ Tambah Penilaian
              </Button>
            </Box>
          }
          sx={{ pb: 2 }}
        />
        <Divider />
        <CardContent>
          {/* Filter Section */}
          <Box sx={{ 
            mb: 3, 
            p: 3, 
            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover', 
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'grey.200'
          }} className="bg-gradient-to-r from-gray-50 to-blue-50 border-gray-200 shadow-sm animate-slide-up">
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Cari Karyawan"
                  variant="outlined"
                  value={searchText}
                  onChange={handleSearchChange}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      bgcolor: (theme) => theme.palette.background.paper
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    value={statusFilter}
                    onChange={handleStatusFilterChange}
                    displayEmpty
                    startAdornment={
                      <InputAdornment position="start">
                        <FilterIcon color="action" />
                      </InputAdornment>
                    }
                    sx={{
                      borderRadius: 2,
                      bgcolor: (theme) => theme.palette.background.paper
                    }}
                  >
                    <MenuItem value="">
                      <em>Semua Status</em>
                    </MenuItem>
                    {uniqueStatuses.map(status => (
                      <MenuItem key={status} value={status}>
                        {status}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    value={periodFilter}
                    onChange={handlePeriodFilterChange}
                    displayEmpty
                    sx={{
                      borderRadius: 2,
                      bgcolor: (theme) => theme.palette.background.paper
                    }}
                  >
                    <MenuItem value="">
                      <em>Semua Periode</em>
                    </MenuItem>
                    {uniquePeriods.map(period => (
                      <MenuItem key={period} value={period}>
                        {period}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main' }}>
                    {filteredData.length}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Total Record
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Table Section */}
          <Box sx={{ 
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: 2,
            overflow: 'hidden'
          }}>
            {loading ? (
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: 400,
                flexDirection: 'column',
                gap: 2
              }}>
                <CircularProgress size={60} />
                <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                  Memuat data penilaian...
                </Typography>
              </Box>
            ) : (
              <>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}>
                          No
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem',
                          minWidth: 200
                        }}>
                          Karyawan
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}>
                          Periode
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}>
                          Evaluator
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}>
                          Skor Keseluruhan
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}>
                          Status
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}>
                          Tanggal Evaluasi
                        </TableCell>
                        <TableCell sx={{ 
                          bgcolor: 'primary.main', 
                          color: 'white', 
                          fontWeight: 600,
                          fontSize: '0.875rem',
                          textAlign: 'center'
                        }}>
                          Aksi
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredData
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((record, index) => (
                        <TableRow 
                          key={record.id}
                          sx={{ 
                            '&:hover': { 
                              bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover',
                              transform: 'scale(1.001)',
                              transition: 'all 0.2s ease'
                            },
                            '&:nth-of-type(even)': {
                              bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'action.hover'
                            }
                          }}
                        >
                          <TableCell sx={{ fontWeight: 500 }}>
                            {index + 1 + page * rowsPerPage}
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <Avatar 
                                sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}
                              >
                                {record.employee.name.charAt(0)}
                              </Avatar>
                              <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                  {record.employee.name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                                  {record.employee.position}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                                  {record.employee.department}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {record.period}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {record.evaluator}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <StarIcon sx={{ fontSize: 20, color: 'warning.main' }} />
                              <Typography variant="h6" sx={{ 
                                fontWeight: 700, 
                                color: record.overallScore > 0 
                                  ? theme.palette[getScoreColor(record.overallScore)].main 
                                  : 'text.secondary',
                                fontSize: '1.1rem'
                              }}>
                                {record.overallScore > 0 ? record.overallScore.toFixed(1) : '-'}
                              </Typography>
                              {record.overallScore > 0 && (
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                  / 5.0
                                </Typography>
                              )}
                            </Box>
                            {record.overallScore > 0 && (
                              <LinearProgress 
                                variant="determinate" 
                                value={(record.overallScore / 5) * 100} 
                                sx={{ 
                                  mt: 0.5,
                                  height: 6,
                                  borderRadius: 3,
                                  bgcolor: alpha(theme.palette[getScoreColor(record.overallScore)].main, 0.1),
                                  '& .MuiLinearProgress-bar': {
                                    bgcolor: theme.palette[getScoreColor(record.overallScore)].main
                                  }
                                }}
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            <Chip 
                              label={record.status}
                              color={getStatusColor(record.status)}
                              size="small"
                              icon={record.status === 'Completed' ? <CheckCircleIcon /> : <PendingIcon />}
                              sx={{ fontWeight: 600 }}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {record.evaluationDate ? new Date(record.evaluationDate).toLocaleDateString('id-ID') : '-'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                              <IconButton
                                size="small"
                                onClick={() => navigate(`/penilaian-kinerja/view/${record.id}`)}
                                sx={{ color: 'primary.main' }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => navigate(`/penilaian-kinerja/edit/${record.id}`)}
                                sx={{ color: 'warning.main' }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => {}}
                                sx={{ color: 'error.main' }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    borderTop: '1px solid',
                    borderColor: 'grey.200',
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'action.hover'
                  }}
                />
              </>
            )}
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default PenilaianKinerjaPage;
